<div class="dialoghead ritual-praxis-btn-modal">
  <mat-dialog-content>
    <h2 style="text-align: center; margin: 10px 0 20px;">
      Choose Your Ritual
    </h2>

    <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 20px; margin-bottom: 10px;">
      <button (click)="onClickRitualButton('Standard Banishing Ritual of the Pentagram')" style="width: 100%;">
        Standard Banishing Ritual of the Pentagram
      </button>
      <button (click)="onClickRitualButton('Standard Invocation Ritual of the Pentagram')">
        Standard Invocation Ritual of the Pentagram
      </button>
    </div>

    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 30px;">
      <button (click)="onClickRitualButton('Divine Infinite Being Invocation Ritual of the Pentagram')">
        Divine Infinite Being Invocation Ritual of the Pentagram
      </button>
      <button (click)="onClickRitualButton('Planetary Zodiacal Invocation Ritual of the Pentagram')">
        Planetary Zodiacal Invocation Ritual of the Pentagram
      </button>
    </div>
  </mat-dialog-content>
</div>

<ng-container *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>

<span mat-button mat-dialog-close class="close-btn-modal material-icons">
  close
</span>
